<template>
  <v-sheet
      :color="status===0 ? '' : status===1 ? 'warning' : status===2 ? 'error' : 'transparent'"
      class="px-1 caption"
      :class="status===0 ? '' : status===1 ? 'white--text' : status===2 ? 'white--text' : ''"
      rounded
  >
    {{$tools.dateFormat(chat.info.updated, true)}}
  </v-sheet>
</template>

<script>
import moment from "moment/moment";

export default {
  props: ['chat','type','text'],
  data: () => ({
    status:null,
  }),
  mounted() {
    if(
        (this.type==='queue' || this.type==='process') &&
        this.chat?.info.messageLast?.info.user.userType==='client'
    ){
      let t = moment(this.chat.info.updated, 'YYYY-MM-DD HH:mm:ss')
      let d = moment().diff(t, 'minutes')
      this.status = 0;
      if(d>15) this.status = 1;
      if(d>60) this.status = 2;
    }
  }
}
</script>